export const tableInitialState = {
  organizations: [],
  customers: [],
  page: 1
}

export const tableReducer = (state, action) => {
  if (action.state) {
    return {
      ...state,
      ...action.state
    }
  } else if (action.page) {
    return {
      ...state,
      page: action.page
    }
  } else if (action.organizations) {
    return {
      ...state,
      organizations: action.organizations
    }
  } else if (action.customers) {
    return {
      ...state,
      customers: action.customers
    }
  }
  return state
}
